import React, { useEffect, useState } from "react";
import ListView from "../../../utils/Custom/listView";
import { fetchQuery } from "../../../utils/commonComponent/fetched";
import { SearchToggleButton } from "../../../utils/Custom/Button";
import { AutoCompletes, DateInput } from "../../../utils/Custom/custominput";
import ExcelDownload from "../../../utils/commonComponent/ExcelDownload";
import moment from "moment";
import { getFormattedDates } from "../../../utils/utils";
import { Autocomplete, Checkbox, TextField } from "@mui/material";
import { getPermissions } from "../rbac/hasAccess";

const headers = [ "id", "Client", "poNumber", "jobNumber", "inspectionNumber", "visitDate", "inspectorName"];

const notNeededColumn = [ "status", "client_id", "servicesNameId", "id", "inspectorId", "jobRegisterId"];

const WorkReport = (props) => {
  const permissions = getPermissions(props.moduleId);
  const [employeesNameList, setEmployeesNameList] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [selectedEmpIds, setSelectedEmpIds] = useState([]);
  const [from, setFromDate] = useState(null);
  const [to, setToDate] = useState(null);

  const [workReportList, setWorkReportList] = useState([]);
  const [searched, setSearched] = React.useState(false);

  const getQuery = () => {
    let whereConditions = "";

    whereConditions += whereConditions
      ? ` AND ir.inspectorId in  (${selectedEmpIds
          ?.map((id) => `'${id}'`)
          .join(",")})`
      : `WHERE ir.inspectorId in  (${selectedEmpIds
          ?.map((id) => `'${id}'`)
          .join(",")})`;

    if (to != null && from != null) {
      const { fromDate, toDate } = getFormattedDates(from, to);
      if (whereConditions === "") {
        whereConditions = " where ";
      } else {
        whereConditions += " and ";
      }
      whereConditions += ` DATE(ir.visitDate) BETWEEN '${fromDate}' and '${toDate}'`;
    }

     if (selectedStatus == 2) {
    whereConditions += whereConditions ? " AND" : " WHERE";
    whereConditions += ` ir.issueDate IS NULL`;
  } else if (selectedStatus == 3) {
    whereConditions += whereConditions ? " AND" : " WHERE";
    whereConditions += ` ir.issueDate IS NOT NULL`;
  }

    let query = `SELECT 
    c.companyName as Client,
    jr.poNumber,
    jri.inspectionNumber,
    jr.jobNumber,
    ir.reportNo,
    ir.issueDate,
    ir.visitDate,
    u.userName AS inspectorName
    FROM IR ir
    LEFT JOIN users u ON u.id = ir.inspectorId
    LEFT JOIN jobRegisterInspection jri ON jri.id = ir.jobRegisterInspectionId
    LEFT JOIN jobRegister jr ON jr.id = jri.jobRegisterId
    LEFT JOIN clients c ON jr.clientId = c.id
    ${whereConditions} ORDER BY ir.id DESC;`;

    return query?.trim()?.replace(/\s+/g, " ");
  };

  const fetchinspectionTaskSummary = async () => {
    try {
      const query = getQuery();
      const inspectionData = await fetchQuery(query);
      const modifiedData = inspectionData.map((item) => ({
        ...item,
        issueDate: item.issueDate
          ? moment(item.issueDate).format("DD-MM-YYYY")
          : "",
        visitDate: item.visitDate
          ? moment(item.visitDate).format("DD-MM-YYYY")
          : "",
      }));
      setWorkReportList(modifiedData);
    } catch (error) {
      console.error("Error fetching inspectionData data:", error);
    }
  };

  const handleSearch = () => {
    if (selectedEmpIds?.length < 1) {
      alert("Please select a employee.");
      return;
    }
    fetchinspectionTaskSummary();
    setSearched(true);
  };

  const clearSearch = () => {
    setSearched(false);
    setSelectedEmpIds([]);
    setSelectedStatus(null);
    setWorkReportList([]);
    setFromDate(null);
    setToDate(null);
  };

  const fetchinspectorsList = async () => {
    const query = `SELECT id, userName FROM users WHERE status = 1 and type = 2`;
    const res = await fetchQuery(query);
    const inpectorNmaes = res?.map((job) => ({
      id: job.id,
      label: job.userName,
    }));
    setEmployeesNameList(inpectorNmaes);
  };

  useEffect(() => {
    fetchinspectorsList();
  }, []);

  return (
    <>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-6 gap-2 my-3">
        <div className="w-full">
          <AutoCompletes
            label="Status"
            options={[
              // { id: 1, label: "Assign" },
              { id: 2, label: "Pending" },
              { id: 3, label: "Completed" },
            ]}
            value={selectedStatus}
            onChange={(val) => {
              setSelectedStatus(val);
            setSearched(false);
            }}
            isWidth
            valueKey="id"
            labelKey="label"
          />
        </div>
        <div className="w-full">
          <Autocomplete
            size="small"
            id="combo-box-demo"
            options={[
              { id: "selectAll", label: "Select All" },
              ...employeesNameList,
            ]}
            disableCloseOnSelect
            multiple
            limitTags={3}
            value={employeesNameList?.filter((option) =>
              selectedEmpIds.includes(option.id)
            )}
            onChange={(event, value) => {
              const selectedIds = value.map((e) => e.id);

              if (selectedIds.includes("selectAll")) {
                // If "Select All" is selected, select all options
                if (
                  selectedEmpIds.length === employeesNameList?.length
                ) {
                  // If all are selected, remove "Select All"
                  setSelectedEmpIds([]);
                } else {
                  // Select all options
                  setSelectedEmpIds(employeesNameList.map((e) => e.id));
                }
              } else {
                setSelectedEmpIds(selectedIds);
              }
              setSearched(false);
            }}
            renderOption={(props, option, { selected }) => (
              <li {...props}>
                <Checkbox
                  style={{ marginRight: 8 }}
                  checked={
                    option.id === "selectAll"
                      ? selectedEmpIds.length ===
                        employeesNameList.length
                      : selectedEmpIds.includes(option.id)
                  }
                />
                {option.label}
              </li>
            )}
            renderInput={(params) => (
              <TextField {...params} label="Select Inspector" />
            )}
          />
        </div>
        <div className="w-full">
          <DateInput
            id="from-date"
            label="From Date"
            value={from}
            onChange={(val) => {
              setFromDate(val);
              setSearched(false);
            }}
          />
        </div>
        <div className="w-full">
          <DateInput
            id="to-date"
            label="To Date"
            value={to}
            onChange={(val) => {
              setToDate(val);
              setSearched(false);
            }}
          />
        </div>
        <div>
          <SearchToggleButton
            searched={searched}
            onSearch={handleSearch}
            onClear={clearSearch}
          />
        </div>
        {workReportList?.length > 0 && (permissions.excelDownload || permissions.allAccess) && (
          <div>
            <ExcelDownload
              finalData={workReportList}
              notNeededColumn={notNeededColumn}
            />
          </div>
        )}
      </div>

      <ListView headers={headers} data={workReportList} />
    </>
  );
};

export default WorkReport;
